import { AdjustmentConfig, FeatureDecisionResult, Splits } from '../../types/split.type';
import { useDecision } from '@optimizely/react-sdk';
import { Reservation } from 'guest-data-types-ts-lib';
import _ from 'lodash';

export const useFeatureConfig = <T>(featureKey: Splits, autoUpdate: boolean): FeatureDecisionResult<T> => {
    const [decision, clientReady] = useDecision(featureKey, { autoUpdate });
    const { enabled: isEnabled, variables } = decision;
    const config = variables?.config as T | null;

    return { isEnabled, config, clientReady };
};

export const isFeatureAvailableForChannel = (
    reservation: Reservation | undefined,
    featureClientReady: boolean,
    featureConfig: AdjustmentConfig | null,
    isFeatureEnable: boolean
): boolean => {
    if (featureClientReady && isFeatureEnable && !_.isNil(featureConfig)) {
        const allowedChannel: boolean = featureConfig.allowedChannels.includes(reservation?.reservation_source_id || 0);

        return isFeatureEnable && allowedChannel;
    }
    return false;
};
